import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** 合併 className：clsx 處理條件式，twMerge 解決 Tailwind 類別互相打架 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
